import React from 'react';
import SearchSection from './SearchSection';
import AutoFilters from './AutoFilters';
import HorizontalCategoryFilter from './HorizontalCategoryFilter';
import useProcessedFilterOptions from './useProcessedFilterOptions';
import { DEFAULT_FILTER_DATA, DEFAULT_FILTER_LOADING } from '../utils/filterDataHelpers';

export const CollectionControls = ({
    // Search props
    enableSearch,
    searchTerm,
    onSearchChange,
    onClearSearch,

    // Filter props
    filterOptions = [],
    customFilterValues = {},
    onCustomFilterChange,

    // Filter data (auto-fetched) - structured as objects
    filterData = DEFAULT_FILTER_DATA,

    // Loading states for filter data - structured as object
    filterDataLoading = DEFAULT_FILTER_LOADING,

    // Display options
    showHorizontalCategoryFilter = false
}) => {
    // Process filter options with auto-fetched data
    const processedFilterOptions = useProcessedFilterOptions({
        filterOptions,
        categories: filterData.categories,
        locations: filterData.locations,
        tags: filterData.tags,
    });

    // Check if we should show the horizontal category filter
    const shouldShowHorizontalCategoryFilter = showHorizontalCategoryFilter &&
        filterData.categories &&
        filterData.categories.length > 0;

    // Determine if there are any controls to show
    const hasControls = enableSearch ||
        (processedFilterOptions && processedFilterOptions.length > 0) ||
        shouldShowHorizontalCategoryFilter;

    if (!hasControls) return null;

    return (
        <div className="collection-controls">
            {shouldShowHorizontalCategoryFilter && (
                <HorizontalCategoryFilter
                    categories={filterData.categories}
                    selectedCategoryIds={customFilterValues.category_ids || []}
                    onChange={onCustomFilterChange}
                    loading={filterDataLoading.categories}
                />
            )}

            {enableSearch && (
                <SearchSection
                    searchTerm={searchTerm}
                    onSearchChange={onSearchChange}
                    onClearSearch={onClearSearch}
                />
            )}

            { /*
            <AutoFilters
                filterOptions={processedFilterOptions}
                filterValues={customFilterValues}
                onFilterChange={onCustomFilterChange}
                filterDataLoading={filterDataLoading}
            />
            */ }
        </div>
    );
};

export default CollectionControls;
